import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { AddressIcon, Close, Phone, Loader } from "../icons";
import Input from "../common/Input";

export default function VendorModal({
  open,
  onClose,
  onSubmit,
  mode = "add",
  initialValues = {},
  isLoading = false,
}) {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    address: "",
  });
  const [fieldErrors, setFieldErrors] = useState({});


  useEffect(() => {
    if (!open) return;
    setFieldErrors({});

    if (mode === "edit" && initialValues) {
      setFormData({
        name: initialValues.name || "",
        phoneNumber: initialValues.phoneNumber || "",
        email: initialValues.email || "",
        address: initialValues.address || "",
      });
    } else {
      setFormData({ name: "", phoneNumber: "", email: "", address: "" });
    }
  }, [open, mode, initialValues]);

  const validate = () => {
    const errors = {};
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^[0-9+\-() ]{7,20}$/;

    if (!formData.name.trim()) {
      errors.name = "Name is required.";
    }

    if (!formData.phoneNumber.trim()) {
      errors.phoneNumber = "Phone number is required.";
    } else if (!phonePattern.test(formData.phoneNumber.trim())) {
      errors.phoneNumber = "Invalid phone number.";
    }

    if (formData.email.trim() && !emailPattern.test(formData.email.trim())) {
      errors.email = "Invalid email address.";
    }

    if (!formData.address.trim()) {
      errors.address = "Address is required.";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };


  async function handleSubmit() {
    const isValid = validate();
    if (!isValid) {
      return;
    }

    try {
      await onSubmit?.(formData);
      setFieldErrors({});
      setFormData({ name: "", phoneNumber: "", email: "", address: "" });
      onClose?.();
    } catch (error) {
      // Backend errors handled by parent component's toast notification
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="w-full max-w-[620px] pt-[30px] pb-[46px] px-0 max-h-[90vh] overflow-y-auto sm:max-h-none sm:overflow-visible"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-6 px-5 sm:px-7">
          <div>
            <p className="text-xl font-bold leading-6 text-black">
              Supplier Registry
            </p>
            <p className="leading-[17px] text-[#868686] text-xs">
              Strategic Supply Chain Unit
            </p>
          </div>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-6 px-5 sm:px-9 space-y-8">


          <Input
            label={<span>Entity Name<span className="text-red-500 ml-1">*</span></span>}
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="Enter E.g Allied Supplies LTD "
            error={fieldErrors.name}
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 ">
            <Input
              label={<span>Direct Contact<span className="text-red-500 ml-1">*</span></span>}
              value={formData.phoneNumber}
              onChange={(e) =>
                setFormData({ ...formData, phoneNumber: e.target.value })
              }
              placeholder="Enter Contact Number "
              icon={<Phone color="#A2A1A8" />}
              error={fieldErrors.phoneNumber}
            />

            <Input
              label="Business Email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              placeholder="Enter Email"
              icon={<AddressIcon />}
              error={fieldErrors.email}
            />
          </div>

          <Input
            label={<span>Fulfillment Office Address<span className="text-red-500 ml-1">*</span></span>}
            value={formData.address}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            placeholder="Physical Contact for logistic and returns "
            error={fieldErrors.address}
          />

          <div className="mt-10">
            <button
              onClick={handleSubmit}
              disabled={isLoading}
              className="w-full bg-[#6D4E8A] text-white py-3 font-bold text-sm rounded-[5px] flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isLoading && <Loader />}
              {isLoading ? "Saving..." : "Commit to Registry"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
